import React, { memo, useEffect, useState, useContext } from 'react';
import { Card, H3 } from 'tea-component';
import { SortBy } from 'tea-component/lib/table/addons';
import Table from './components/Table';
import { useRequest, useUpdateEffect } from 'ahooks';
import { fetchStudioOverallProjectsCostData } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import { getValidDate } from '@gp/utils/common';
import { context as Context } from '@gp/components/Context';
import './index.scss';
import CardSlot from '@/pages/globalpedia/components/CardSlot';

interface CostPropsType {
  type: 1 | 2; // 1: Monthly 2: Quarterly
  subTitle: string;
}

const DEFAULT_PROPS: CostPropsType = {
  type: 1,
  subTitle: '',
};

function Cost(props: CostPropsType) {
  const { type, subTitle } = props;

  const { filter }: StudioOverallProjectsContextType =
    useContext(Context) || {};

  const [sortsParams, setSortsParams] = useState<SortBy<any>>({
    by: '',
    order: 'desc' as any,
  });

  const { loading, data, run } = useRequest(
    fetchStudioOverallProjectsCostData,
    { manual: true },
  );

  // 排序发生改变调用接口
  useUpdateEffect(() => {
    run({
      type: type,
      bo: filter?.bo || [],
      project: filter?.project || [],
      order: sortsParams?.order,
      order_metrics: sortsParams?.by,
    });
  }, [sortsParams?.by, sortsParams?.order]);

  // 筛选器发生变化
  useEffect(() => {
    run({
      type: type,
      bo: filter?.bo || [],
      project: filter?.project || [],
      order: sortsParams?.order,
      order_metrics: sortsParams?.by,
    });
  }, [filter]);

  return (
    <CardSlot
      className="dbg-studio-overall-projects-development-cost"
      title={
        <div>
          Cost
          <span className="dbg-studio-overall-time">
            {subTitle?.replace(
              '-',
              getValidDate(data?.update_time || '', 'YYYY-MM'),
            )}
          </span>
        </div>
      }
    >
      <Table data={data} loading={loading} setSortsParams={setSortsParams} />
    </CardSlot>
  );
}

Cost.defaultProps = DEFAULT_PROPS;

export default memo(Cost);
